export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.4915abbe2b23b40bb47f8ebc42afbafb.css";